<template>
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-link :href="href">
      <img class="mx-2" src="@/assets/logo.png" alt="Logo">
      <b-navbar-brand>{{ title }}</b-navbar-brand>
    </b-link>
    <user-profile></user-profile>
  </b-navbar>
</template>

<script>
import { mapState } from "vuex";
import UserProfile from "@/components/UserProfile.vue";
export default {
  name: "CourseNav",
  data() {
    return {
      /** 起始页面 */
      href: process.env.VUE_APP_PHONETICS_HOME_URL || 'https://johnslanguages.com',
      /** 题目 */
      title: process.env.VUE_APP_TITLE
    }
  },
  components: {
    UserProfile
  },
  computed: {
    ...mapState('auth', ['currentUser'])
  }
}
</script>

<style scoped>

</style>
